// extracted by mini-css-extract-plugin
export default {"row_wrapper":"ProjectProtocolsTableDummyRow_row_wrapper__SYeDw","row":"ProjectProtocolsTableDummyRow_row__EPAHv"};